import { useEffect } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import BreadcrumbsComponent from "@atoms/Breadcrumbs/Breadcrumbs";
import color from "@definitions/mui/color";
import Text from "@ds/components/Text";
import { gtmCustomEvent } from "@helpers/analytics";
import FormInterest from "../../form";
import useStyles from "./styles";
import { useTranslation } from "next-i18next";
import useResponsive from "@helpers/useResponsive";

function InterestForm() {
  const classes = useStyles();
  const { t } = useTranslation("common");
  const isMD = useResponsive("md");

  useEffect(() => {
    const timeoutFetch = setTimeout(() => {
      gtmCustomEvent(
        {
          eventAction: "Akses Interest Form - General",
          eventCategory: "WebPages",
          eventLabel: "Interest Form - General",
        },
        "LeadGeneral",
      );
    }, 1000);
    return () => window.clearTimeout(timeoutFetch);
  }, []);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={`${process.env.NEXT_PUBLIC_SITE_KEY}`}>
      <Box position="relative">
        <Box bgcolor={color.grey.mid} py={1} width="100%" mt={9}>
          <Container maxWidth="lg" disableGutters>
            <BreadcrumbsComponent
              homeUrl={{ label: t("root"), productPath: "/" }}
              breadcrumbs={[{ label: "Interested Form" }]}
            />
          </Container>
        </Box>
        <Box bgcolor="white" pt={8} pb={12}>
          <Box maxWidth={isMD ? "auto" : 540} margin="auto">
            <Text className={classes.title} align="center" variant="h1" weight="700">
              {t("formInterest.title")}
            </Text>
            <Text align="center" component="p" color="inactive-secondary" variant="body1">
              {t("formInterest.desc")}
            </Text>
            <FormInterest />
          </Box>
        </Box>
      </Box>
    </GoogleReCaptchaProvider>
  );
}

export default InterestForm;
